import { render, staticRenderFns } from "./payments.vue?vue&type=template&id=ac737ddc&scoped=true&"
import script from "./payments.vue?vue&type=script&lang=js&"
export * from "./payments.vue?vue&type=script&lang=js&"
import style0 from "./payments.vue?vue&type=style&index=0&lang=css&"
import style1 from "./payments.vue?vue&type=style&index=1&id=ac737ddc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac737ddc",
  null
  
)

export default component.exports